"use client";

export default function ThemeToggle() {
  return null;
}
